const FormBuilder = () => import(/* webpackChunkName: "admin" */ '@/features/admin/form-builder/index.vue');

export default {
  component: FormBuilder,
  name: 'admin.form-builder',
  path: 'form-builder',
};
